
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","fill-rule":"evenodd","d":"M4.993 6.997a4 4 0 118 0v10.006a2 2 0 104 .001V5.995h-2a.5.5 0 01-.35-.85l3-3.002a.51.51 0 01.71 0l3 3.002a.5.5 0 01-.36.85h-2v11.007a4 4 0 11-8 0V6.997a2 2 0 10-4-.001v11.008h2a.499.499 0 01.36.85l-3 3.002a.51.51 0 01-.71 0l-3-3.002a.5.5 0 01.35-.85h2V6.997z"}})])
          )
        }
      }
    